import { render } from "./service-ended.vue?vue&type=template&id=003c5af0"
import script from "./service-ended.vue?vue&type=script&lang=js"
export * from "./service-ended.vue?vue&type=script&lang=js"

import exportComponent from "/Users/apspc001/work/dev/ccc/ccc-codes/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__